export default function AppSection() {
  return (
    <section id="app" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex flex-col lg:flex-row items-center gap-8 lg:gap-14">
          <div className="flex-1 text-center lg:text-left">
            <h2 className="text-2xl md:text-3xl font-heading text-foreground-950 mb-4">移动追剧</h2>
            <p className="text-foreground-600 text-sm md:text-base leading-relaxed mb-6 max-w-md mx-auto lg:mx-0">
              下载久久影视手机客户端，随时随地畅享电视剧全集免费在线观看体验。离线缓存、倍速播放、夜间模式，追剧更自由。
            </p>
            <div className="flex flex-wrap items-center gap-3 justify-center lg:justify-start">
              <div className="inline-flex items-center gap-2 px-5 py-3 rounded-lg bg-foreground-900 text-white cursor-pointer hover:bg-foreground-800 transition-colors whitespace-nowrap">
                <i className="ri-apple-fill text-lg"></i>
                <div className="text-left">
                  <div className="text-xs opacity-70">Download on the</div>
                  <div className="text-sm font-semibold">App Store</div>
                </div>
              </div>
              <div className="inline-flex items-center gap-2 px-5 py-3 rounded-lg bg-foreground-900 text-white cursor-pointer hover:bg-foreground-800 transition-colors whitespace-nowrap">
                <i className="ri-google-play-fill text-lg"></i>
                <div className="text-left">
                  <div className="text-xs opacity-70">GET IT ON</div>
                  <div className="text-sm font-semibold">Google Play</div>
                </div>
              </div>
            </div>
            <div className="mt-5 flex items-center gap-5 justify-center lg:justify-start text-sm text-foreground-500">
              <span className="flex items-center gap-1"><i className="ri-download-line"></i> 500万+ 下载</span>
              <span className="flex items-center gap-1"><i className="ri-star-fill text-accent-500"></i> 4.8 评分</span>
            </div>
          </div>
          <div className="flex-1 flex justify-center">
            <div className="relative w-64 md:w-72">
              <img
                src="https://readdy.ai/api/search-image?query=Modern%20smartphone%20mockup%20displaying%20abstract%20entertainment%20streaming%20interface%20with%20warm%20coral%20and%20golden%20color%20scheme%2C%20clean%20minimal%20UI%20design%20with%20video%20thumbnails%2C%20floating%20on%20soft%20gradient%20background%2C%20premium%20product%20presentation%20style%2C%20no%20text%20or%20specific%20branding&width=800&height=1400&seq=app-mockup-jiujiu&orientation=portrait"
                alt="久久影视移动端"
                className="w-full h-auto object-contain"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}